import React from 'react';
import PropTypes from 'prop-types';
import style from '../../../styles/styles';
import { List, Paper, Subheader, TextField } from 'material-ui';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';

class DynamicLinkSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        editConfiguration: PropTypes.func,
    };

    static defaultProps = {
        app: null,
        loading: false,
    };

    handleDynamicLinksDomain = (event) => {
        this.props.editConfiguration('dynamic_links_domain', event.target.value);
    };
    handleDynamicLinksLink = (event) => {
        this.props.editConfiguration('dynamic_links_link', event.target.value);
    };
    handleAndroidPackageName = (event) => {
        this.props.editConfiguration('android_package_name', event.target.value);
    };
    handleIosBundleId = (event) => {
        this.props.editConfiguration('ios_bundle_id', event.target.value);
    };
    handleIosAppStoreId = (event) => {
        this.props.editConfiguration('ios_app_store_id', event.target.value);
    };

    render() {
        const {
            loading,
            app,
        } = this.props;
        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else {
            content =
                <div>
                    <TextField
                        floatingLabelText={this.props.t('module.dynamic_link.dynamic_links_domain')}
                        defaultValue={app.configurations.dynamic_links_domain}
                        fullWidth={true}
                        onBlur={this.handleDynamicLinksDomain}
                    />
                    <TextField
                        floatingLabelText={this.props.t('module.dynamic_link.dynamic_links_link')}
                        defaultValue={app.configurations.dynamic_links_link}
                        fullWidth={true}
                        onBlur={this.handleDynamicLinksLink}
                    />
                    <TextField
                        floatingLabelText={this.props.t('module.dynamic_link.android_package_name')}
                        defaultValue={app.configurations.android_package_name}
                        fullWidth={true}
                        onBlur={this.handleAndroidPackageName}
                    />
                    <TextField
                        floatingLabelText={this.props.t('module.dynamic_link.ios_bundle_id')}
                        defaultValue={app.configurations.ios_bundle_id}
                        fullWidth={true}
                        onBlur={this.handleIosBundleId}
                    />
                    <TextField
                        floatingLabelText={this.props.t('module.dynamic_link.ios_app_store_id')}
                        defaultValue={app.configurations.ios_app_store_id}
                        fullWidth={true}
                        onBlur={this.handleIosAppStoreId}
                    />
                </div>;
        }

        return <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.dynamic_link.name')}
                </Subheader>

                <div style={style.paper}>
                    {content}
                </div>
            </List>
        </Paper>;
    }
}

export default withTranslation(DynamicLinkSetting);



// WEBPACK FOOTER //
// src/components/common/DynamicLinkSetting/DynamicLinkSetting.js